"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumPharmacy = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const PremiumPharmacy_styles_1 = require("./PremiumPharmacy.styles");
const atome_1 = require("../../../../atome");
const react_native_star_rating_widget_1 = __importDefault(require("react-native-star-rating-widget"));
const PremiumCheck_1 = require("../../../../atome/Icon/Icons/PremiumCheck");
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const PremiumPharmacy = ({ navigation, pharmacy }) => {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [showDetails, setShowDetails] = (0, react_1.useState)(false);
    const disable = pharmacy.id === userInformation.patientPharmacyRelation?.id;
    const Details = () => (react_1.default.createElement(react_native_1.View, { key: pharmacy.id },
        react_1.default.createElement(atome_1.Text, { children: pharmacy.descriptionShort, style: [PremiumPharmacy_styles_1.styles.pharmacyDescription] }),
        react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_styles_1.styles.divider },
            react_1.default.createElement(react_native_1.Pressable, { style: PremiumPharmacy_styles_1.styles.buttonGreen, onPress: () => navigation.navigate('PharmacyDetails', {
                    chosenPharmacy: pharmacy,
                }), disabled: false },
                react_1.default.createElement(atome_1.Text, { style: [PremiumPharmacy_styles_1.styles.buttonTextGreen] }, "Details")),
            react_1.default.createElement(react_native_1.Pressable, { style: disable ? PremiumPharmacy_styles_1.styles.buttonWhiteDisabled : PremiumPharmacy_styles_1.styles.buttonWhite, onPress: () => navigation.navigate('PharmacyConfirmation', {
                    chosenPharmacy: pharmacy,
                }), disabled: disable },
                react_1.default.createElement(atome_1.Text, { style: [
                        disable ? PremiumPharmacy_styles_1.styles.buttonTextWhiteDisabled : PremiumPharmacy_styles_1.styles.buttonTextWhite,
                    ] }, disable ? 'Ausgewählte Apotheke' : 'Apotheke Wählen')))));
    return (react_1.default.createElement(react_native_1.View, { style: [PremiumPharmacy_styles_1.styles.rectanglePremium] },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => setShowDetails(!showDetails), style: { height: 80 } },
            react_1.default.createElement(react_native_1.Image, { source: {
                    height: 35,
                    width: 240,
                    uri: 'data:image/jpg;base64,' + pharmacy.image,
                }, style: [PremiumPharmacy_styles_1.styles.imageStyle] })),
        showDetails ? react_1.default.createElement(Details, null) : react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_styles_1.styles.detailsLine }),
        react_1.default.createElement(react_native_1.View, { style: [PremiumPharmacy_styles_1.styles.ratingRow] },
            react_1.default.createElement(PremiumCheck_1.PremiumCheck, { color: "#e3e3e3", styles: [{ marginRight: 5 }] }),
            react_1.default.createElement(atome_1.Text, { style: [PremiumPharmacy_styles_1.styles.premiumText] }, "Beliebte Apotheke"),
            react_1.default.createElement(react_native_star_rating_widget_1.default, { rating: pharmacy.rating, onChange: () => { }, starSize: 16, color: "#e3e3e3", style: PremiumPharmacy_styles_1.styles.starsStyles, starStyle: PremiumPharmacy_styles_1.styles.starStyles }))));
};
exports.PremiumPharmacy = PremiumPharmacy;
